<script setup lang="ts">
// A pixel icon. Monochrome cells (`ink`) take the theme's ink: white on dark, black on light;
// other colours are drawn with 3:1 contrast on the theme (forTheme).
import { forTheme } from '../lib/color'
import { INK, type PixelIcon } from '../lib/pixels'
import { activeTheme } from '../lib/theme'

defineProps<{ icon: PixelIcon }>()
const draw = (c: string) => forTheme(c, activeTheme.value === 'dark')
</script>

<template>
  <svg viewBox="0 0 7 7" class="h-full w-full" shape-rendering="crispEdges" data-testid="avatar-pixels">
    <template v-for="(c, i) in icon.cells" :key="i">
      <rect
        v-if="c"
        :x="i % 7"
        :y="Math.floor(i / 7)"
        width="1"
        height="1"
        :class="icon.colors[c - 1] === INK ? 'fill-text-primary' : ''"
        :fill="icon.colors[c - 1] === INK ? undefined : draw(icon.colors[c - 1]!)"
        :data-color="icon.colors[c - 1]"
      />
    </template>
  </svg>
</template>
